import {CardAgreementType} from 'src/cassandra'
import {CardAccountAgreements} from 'src/products/card/CardsHistory/UseCardDocuments/useCardDocuments'

export const hasAgreement = (
  agreementType: CardAgreementType,
  agreements: CardAccountAgreements,
): boolean => {
  return agreements.some((agreement) => agreement.type === agreementType)
}
